import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { CSS_MQ } from "../../styles/breakpoints";
import React from "react";

import { css } from "@emotion/react";
import { CSS_COLORS } from "../../styles/styles-css-variables";
import { ProductClickAndInfoType } from "@swo/storefront";
import { LeftArrowSvg, RightArrowSvg } from "../../assets";

export const HotSpotNavigation: ReactTFC<{
  onNavigationRequested: (dir: "back" | "forward") => void;
  translations: ProductClickAndInfoType["translations"];
}> = props => {
  return (
    <div
      css={css`
        display: flex;
        margin-left: -6px;

        ${CSS_MQ.atMostSm} {
          justify-content: space-between;
          margin-right: -6px;
        }
      `}
    >
      <button onClick={() => props.onNavigationRequested("back")} css={buttonStyles}>
        <LeftArrowSvg />
        <span>{props.translations.previousLabel.value}</span>
      </button>

      <button onClick={() => props.onNavigationRequested("forward")} css={buttonStyles}>
        <span>{props.translations.nextLabel.value}</span>
        <RightArrowSvg />
      </button>
    </div>
  );
};

const buttonStyles = css`
  display: inline-flex;
  align-items: center;
  color: ${CSS_COLORS.Green};

  svg {
    height: 20px;
    width: auto;
    color: inherit;

    margin-bottom: 2px; // visually center
  }

  span {
    text-transform: uppercase;
    text-decoration: underline;
    color: inherit;

    padding: 0 6px;

    line-height: 1;
  }

  & + & {
    margin-left: 40px;
  }
`;
